import { UserProfileDistribution } from "@/types/profile-distribution.type";
import { getUserProfileColor } from "../colors/user-profiles";
import { buildDistributionChart } from "./build-distribution-chart.util";
import { ChartOption } from "@/helper/chart/types/chart-option.type";
import { chartOptionDefault } from "@/helper/chart/constants/chart-option-default.const";

export const getUserProfilesChart = (
  userProfiles: UserProfileDistribution[],
  options: ChartOption = chartOptionDefault,
) => {
  return buildDistributionChart({
    items: userProfiles,
    options,
    getLabel: (profile) => profile.user_profile,
    getColor: (profile) => getUserProfileColor(profile.user_profile),
  });
};
